/* eslint-disable jsx-a11y/anchor-is-valid */
import "./register.css";
import {Home} from "../home/home";
import React, {useEffect, useState, useCallback} from "react";
import {
    backDrop,
    ServerDate,
    showAgreementModal,
    showSelfieExample,
    showSelfieRules,
    useForceUpdate,
} from "../../services/misc.functions";
import {SubmitHandler, useForm} from "react-hook-form";
import {foreignerTCs, nationalities, professions} from "../../constants/global.vars";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import paths from "../../paths";
import backgroundImage from "../../assets/img/riders.jpeg";
import xIcon from "../../assets/feather/x.svg";
import {auth, authSubject} from "../../store/auth.store";
import ReactInputMask from "react-input-mask";
import EyeIcon from "../../assets/feather/eye.svg";
import EyeOffIcon from "../../assets/feather/eye-off.svg";
import SelfieExample from "../../assets/img/kyc_example.jpeg";
import {isMobile} from "../../App";
import InputAuto from "./input.auto";
import {AuthService} from "../../services/auth.service";
import {modalServiceSubject} from "../../services/modal.service";

const years: any = [];
const days: any = [];
const months = [
    {val: "01", name: "01"},
    {val: "02", name: "Şubat"},
    {val: "03", name: "Mart"},
    {val: "04", name: "Nisan"},
    {val: "05", name: "Mayıs"},
    {val: "06", name: "Haziran"},
    {val: "07", name: "Temmuz"},
    {val: "08", name: "Ağustos"},
    {val: "09", name: "Eylül"},
    {val: "10", name: "Ekim"},
    {val: "11", name: "Kasım"},
    {val: "12", name: "Aralık"},
];
let today = ServerDate();
let yy = today.getFullYear() - 18;
for (let i = yy; i >= yy - 100; i--) {
    years.push(i);
}
for (let j = 1; j < 32; j++) {
    days.push(j < 10 ? "0" + j : j.toString());
}

export function Register() {
    const navigate = useNavigate();
    const forceUpdate = useForceUpdate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!isMobile) {
            backDrop(true);
        }
        return () => {
            backDrop(false);
        };
    }, [isMobile]);

    useEffect(() => {
        if (auth.member?.id) {
            navigate(paths.home);
        }
    }, [auth.member?.id]);

    useEffect(() => {
        let auth_subscriber = authSubject.subscribe((res: any) => {
            forceUpdate();
        });
        return () => {
            auth_subscriber.unsubscribe();
        };
    }, []);

    const validateForm = (payload: any) => {
        let isValid = true;
        if (payload.mobile) {
            const mobileDigits = payload.mobile.replace(/\D/g, "");
            if (mobileDigits.length < 10) {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata",
                    content: "Geçerli bir cep telefonu numarası giriniz.",
                });
                isValid = false;
            }
        }

        const emailRegex = /^\S+@\S+\.\S+$/;
        if (!emailRegex.test(payload.email || "")) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                content: "Geçerli bir e-posta adresi giriniz.",
            });
            isValid = false;
        }

        if ((payload.password || "") !== (payload.password_confirm || "")) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                content: "Şifreler eşleşmiyor.",
            });
            isValid = false;
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;
        if (!passwordRegex.test(payload.password || "")) {
            modalServiceSubject.next({
                case: "danger",
                title: "Hata",
                content:
                    "Şifreniz en az 8 karakter uzunluğunda olmalı ve en az bir büyük harf, bir küçük harf ve bir özel karakter içermelidir.",
            });
            isValid = false;
        }
        return isValid;
    };

    const onSubmit: SubmitHandler<any> = async (payload: any) => {
        if (!validateForm(payload)) {
            return;
        }

        const authService = new AuthService(searchParams, navigate);
        await authService.register(payload);
    };

    return (
        <>
            {!isMobile && <Home></Home>}
            {!isMobile && (
                <div className="register-widget">
                    <Link className="btn-close" to={paths.home.url}>
                        <img alt={"kapat"} src={xIcon} height={24}/>
                    </Link>

                    <div className="register-widget-background">
                        <img alt={""} className="register-background-image " src={backgroundImage}/>
                        <img
                            alt={"4nala"}
                            onClick={() => navigate(paths.home.url)}
                            className="register-background-logo cursor-pointer"
                            src="/assets/logo_at_yarisi_hipodrom_4nala_atyarisi.svg"
                        />
                        <div className="register-background-desc">
                            AT YARIŞLARI
                            <br/>
                            HEYECANI
                            <span className="fw-bold text-warning">
                                <br/>
                                YENİDEN
                                <br/>
                                BAŞLIYOR!
                            </span>
                        </div>
                    </div>

                    <div className="w-50 register-form">
                        <h5 className="text-center pb-2">Üye Ol</h5>

                        <RegisterForm onSubmit={onSubmit}/>
                    </div>
                </div>
            )}
            {isMobile && (
                <div className="register-mobile">
                    <div className="register-mobile-header">
                        <img alt={"4nala"} src="/assets/logo_at_yarisi_hipodrom_4nala_atyarisi.svg" width={220}/>
                    </div>
                    <RegisterForm onSubmit={onSubmit}/>
                </div>
            )}
        </>
    );
}

export function RegisterForm(props: any) {
    const onSubmit: any = props.onSubmit;
    const [referenceCode, setReferenceCode] = useState<any>(null);
    const [searchParams] = useSearchParams();
    useEffect(() => {
        if (searchParams.get("referer") != null) {
            setReferenceCode(searchParams.get("referer"));
            setValue("reference_id", searchParams.get("referer"));
        }
    }, []);
    const {
        register,
        handleSubmit,
        formState: {errors},
        setValue,
        clearErrors,
        getValues,
    } = useForm();

    useEffect(() => {
        if (props.referenceCode) {
            setValue("reference_id", searchParams.get("referer"));
        }
    }, []);

    const [showNationality, setShowNationality] = useState<any>(false);
    const [showNationalityError, setShowNationalityError] = useState<any>(false);

    const isPasswordVisible = () => {
        let password: any = document.getElementById("id_password");
        let eyeIcon: any = document.getElementById("eye-icon");

        if (password.type === "password") {
            password.type = "text";
            eyeIcon.src = EyeIcon;
        } else {
            password.type = "password";
            eyeIcon.src = EyeOffIcon;
        }
    };

    const isPasswordVisible2 = () => {
        let password: any = document.getElementById("id_password2");
        let eyeIcon: any = document.getElementById("eye-icon2");

        if (password.type === "password") {
            password.type = "text";
            eyeIcon.src = EyeIcon;
        } else {
            password.type = "password";
            eyeIcon.src = EyeOffIcon;
        }
    };

    const handleAgreementCheckbox = (e: any, agreementType: string) => {
        const {checked} = e.target;
        if (checked) {
            showAgreementModal(agreementType, e);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-row">
                <div className="w-50">
                    <input
                        type="text"
                        placeholder="AD"
                        className={"form-control" + (errors.first_name ? " border-danger" : "")}
                        {...register("first_name", {required: true})}
                    />
                    {errors.first_name && <p className="invalid-feedback">Lütfen adınızı girin</p>}
                </div>
                <div className="w-50">
                    <input
                        type="text"
                        placeholder="SOYAD"
                        className={"form-control" + (errors.last_name ? " border-danger" : "")}
                        {...register("last_name", {required: true})}
                    />
                    {errors.last_name && <p className="invalid-feedback">Lütfen soyadınızı girin</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <input
                        type="tel"
                        maxLength={11}
                        placeholder="TC KİMLİK NO"
                        className={"form-control" + (errors.tc_id ? " border-danger" : "")}
                        {...register("tc_id", {
                            required: true,
                            validate: (value) => value.length === 11 && !value.startsWith("99") && !value.startsWith("98") && !value.startsWith("97")
                        })}
                        onChange={(e: any) => {
                            const onlyDigits = e.target.value.replace(/\D/g, "");
                            e.target.value = onlyDigits;

                            clearErrors("tc_id");
                            if (e.target.value && (e.target.value.startsWith("99") || e.target.value.startsWith("98") || e.target.value.startsWith("97"))) {
                                setShowNationality(false);
                                setShowNationalityError(true);
                            } else {
                                setShowNationality(false);
                                setShowNationalityError(false);
                            }
                        }}
                    />
                    {errors.tc_id && <p className="invalid-feedback">11 Haneli TC kimlik numaranızı girin</p>}
                    {showNationalityError && (
                        <p className="invalid-feedback">Yabancı kimlik no ile üyelikler geçici olarak kapalıdır.</p>
                    )}
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <select
                        className={`form-select w-100 ${!isMobile ? "bg-transparent" : "bg-light"} ${errors.nationality ? "border-danger" : ""}`}
                        {...register("nationality", {
                            required: true, validate: (value) => {
                                if (!value) return "Uyruk gereklidir.";

                                const tcknValue = getValues("tc_id") || "";
                                const tcknPrefix = tcknValue.substring(0, 2);

                                const isForeignerTC = foreignerTCs.includes(parseInt(tcknPrefix));
                                const isSelectedTurkey = parseInt(value) === 999;

                                if (isForeignerTC && isSelectedTurkey) {
                                    return "Kimlik numaranız ile seçtiğiniz uyruk uyuşmuyor. Lütfen bilgilerinizin doğruluğunu kontrol ediniz.";
                                }

                                if (!isForeignerTC && !isSelectedTurkey) {
                                    return "Kimlik numaranız ile seçtiğiniz uyruk uyuşmuyor. Lütfen bilgilerinizin doğruluğunu kontrol ediniz.";
                                }

                                return true;
                            }
                        })}
                    >
                        <option value="" disabled selected>
                            UYRUK BİLGİSİ
                        </option>
                        {nationalities.map((x: any) => {
                            return (
                                <option value={x.id} key={x.name}>
                                    {x.name}
                                </option>
                            );
                        })}
                    </select>

                    {errors.nationality && <p className="invalid-feedback">{errors.nationality.message?.toString()}</p>}
                </div>
            </div>
            {/*{showNationality && (*/}
            {/*    <div className="form-row">*/}
            {/*        <div className="w-100">*/}
            {/*            <select*/}
            {/*                className={`form-select w-100 ${!isMobile ? "bg-transparent" : "bg-light"} ${errors.nationality ? "border-danger" : ""}`}*/}
            {/*                {...register("nationality", { required: true })}*/}
            {/*            >*/}
            {/*                <option value="" disabled selected>*/}
            {/*                    UYRUK BİLGİSİ*/}
            {/*                </option>*/}
            {/*                {nationalities.map((x: any) => {*/}
            {/*                    return (*/}
            {/*                        <option value={x.id} key={x.name}>*/}
            {/*                            {x.name}*/}
            {/*                        </option>*/}
            {/*                    );*/}
            {/*                })}*/}
            {/*            </select>*/}

            {/*            {errors.nationality && <p className="invalid-feedback">Uyruk bilginizi giriniz</p>}*/}

            {/*            <label htmlFor="id_passport_selfie" className="form-label">*/}
            {/*                Selfie ve Pasaport Fotoğrafı (max:5mb){" "}*/}
            {/*            </label>*/}
            {/*            <input*/}
            {/*                type="file"*/}
            {/*                {...register<any>("passport_selfie", { required: true })}*/}
            {/*                className="form-control"*/}
            {/*                id="id_passport_selfie"*/}
            {/*                accept="image/png,image/jpg,image/jpeg"*/}
            {/*            />*/}
            {/*            {errors.passport_selfie && (*/}
            {/*                <div className="form-text text-danger">Selfie ve Pasaport Fotoğrafı gereklidir.</div>*/}
            {/*            )}*/}

            {/*            <p className="mt-1" style={{ fontSize: "12px" }}>*/}
            {/*                Lütfen yüzünüzün net bir şekilde göründüğü, güncel bir fotoğraf yükleyin. Fotoğrafınız; kimlik doğrulama,*/}
            {/*                güvenlik ve topluluk standartlarına uygunluk açısından değerlendirilecektir.*/}
            {/*                <p className="text-align-end text-end">*/}
            {/*                    <a*/}
            {/*                        className="fw-bold pointer me-1"*/}
            {/*                        onClick={() => {*/}
            {/*                            showSelfieRules();*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        Kurallar*/}
            {/*                    </a>*/}
            {/*                    <a*/}
            {/*                        className="fw-bold pointer"*/}
            {/*                        onClick={() => {*/}
            {/*                            showSelfieExample(*/}
            {/*                                <div className="d-flex justify-content-center align-items-center">*/}
            {/*                                    <img width="200" height="200" src={SelfieExample} />*/}
            {/*                                </div>,*/}
            {/*                            );*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        Örnek Görsel*/}
            {/*                    </a>*/}
            {/*                </p>*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*)}*/}
            <div className="form-row">
                <div className="w-100">
                    <label htmlFor="id_birthday" className={`form-label ${!isMobile ? "" : "text-light"}`}>
                        Doğum Tarihi
                    </label>
                    <div className="row">
                        <div className="col d-flex flex-column">
                            <select
                                className={`form-select ${!isMobile ? "bg-transparent" : "bg-light"} ${errors.birthday_day ? "border-danger" : ""}`}
                                {...register("birthday_day", {
                                    required: true,
                                    validate: (value) => value !== "DEFAULT"
                                })}
                                defaultValue={"DEFAULT"}
                            >
                                <option value="DEFAULT" disabled>
                                    Gün
                                </option>
                                {days.map((x: any) => {
                                    return (
                                        <option value={x} key={x}>
                                            {x}
                                        </option>
                                    );
                                })}
                            </select>
                            {errors.birthday_day &&
                                <span className="invalid-feedback text-nowrap">Gün gereklidir.</span>}
                        </div>
                        <div className="col d-flex flex-column">
                            <select
                                className={`form-select ${!isMobile ? "bg-transparent" : "bg-light"} ${errors.birthday_month ? "border-danger" : ""}`}
                                {...register("birthday_month", {
                                    required: true,
                                    validate: (value) => value !== "DEFAULT"
                                })}
                                defaultValue={"DEFAULT"}
                            >
                                <option value="DEFAULT" disabled>
                                    Ay
                                </option>
                                {months.map((x: any) => (
                                    <option value={x.val} key={x.val}>
                                        {x.val}
                                    </option>
                                ))}
                            </select>
                            {errors.birthday_month &&
                                <span className="invalid-feedback text-nowrap">Ay gereklidir.</span>}
                        </div>
                        <div className="col d-flex flex-column">
                            <select
                                className={`form-select ${!isMobile ? "bg-transparent" : "bg-light"} ${errors.birthday_year ? "border-danger" : ""}`}
                                {...register("birthday_year", {
                                    required: true,
                                    validate: (value) => value !== "DEFAULT"
                                })}
                                defaultValue={"DEFAULT"}
                            >
                                <option value="DEFAULT" disabled>
                                    Yıl
                                </option>
                                {years.map((x: any) => (
                                    <option value={x} key={x}>
                                        {x}
                                    </option>
                                ))}
                            </select>
                            {errors.birthday_year &&
                                <span className="invalid-feedback text-nowrap">Yıl gereklidir.</span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <input
                        type="email"
                        placeholder="E-POSTA"
                        className={"form-control" + (errors.email ? " border-danger" : "")}
                        {...register("email", {
                            required: true,
                            pattern: /^\S+@\S+$/i,
                        })}
                    />
                    {errors.email && <p className="invalid-feedback">Geçerli e-posta adresinizi girin</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <ReactInputMask
                        mask="(599) 999 99 99"
                        className={"form-control" + (errors.mobile ? " border-danger" : "")}
                        type={"tel"}
                        placeholder={"CEP TELEFONU"}
                        {...register<any>("mobile", {required: true})}
                    />

                    {errors.mobile && <p className="invalid-feedback">Cep telefonu numaranızı girin</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <InputAuto
                        label="Meslek Bilgisi"
                        pholder="Meslek Seçiniz"
                        data={professions}
                        register={register}
                        name="profession"
                        setValue={setValue}
                        clearErrors={clearErrors}
                        error={errors.profession}
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <input
                        maxLength={8}
                        type="search"
                        autoComplete="off"
                        {...register("reference_id", {required: false})}
                        id="reference_id"
                        placeholder="REFERANS KODU"
                        disabled={referenceCode != null}
                    />
                    <p className="mb-0 mt-1">Referans kodu isteğe bağlıdır ve boş bırakabilirsiniz.</p>
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <input
                        className={"form-control" + (errors.password ? " border-danger" : "")}
                        id="id_password"
                        type="password"
                        placeholder="Şifre"
                        {...register("password", {required: true, minLength: 8})}
                    />
                    <div className="cursor-pointer password-eye" onClick={() => isPasswordVisible()}>
                        <img id="eye-icon" height={16} width={16} src={EyeOffIcon} alt="Toggle visibility"/>
                    </div>
                    {errors.password && <p className="invalid-feedback">En az 8 haneli şifrenizi belirleyin</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <input
                        className={"form-control" + (errors.password_confirm ? " border-danger" : "")}
                        id="id_password2"
                        type="password"
                        placeholder="Şifre (Tekrar)"
                        {...register("password_confirm", {
                            required: "Şifre Tekrar gereklidir",
                            minLength: 8,
                            validate: (value) => {
                                return value === getValues("password") || "Şifreler Eşleşmiyor"
                            }
                        })}
                    />
                    <div className="cursor-pointer password-eye" onClick={() => isPasswordVisible2()}>
                        <img id="eye-icon2" height={16} width={16} src={EyeOffIcon} alt="Toggle visibility"/>
                    </div>
                    {errors.password_confirm &&
                        <p className="invalid-feedback">{errors.password_confirm.message?.toString()}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className={`${isMobile ? "text-light" : ""}`}>
                    <p className="white-space-normal">
                        Şifreniz en az 8 karakter, en fazla 20 karakterden oluşmalı ve aşağıdaki öğeleri içermelidir:
                    </p>
                    <ul>
                        <li>En az bir büyük harf</li>
                        <li>En az bir küçük harf</li>
                        <li>En az bir rakam</li>
                        <li>En az bir özel karakter (!, @, #, vb.)</li>
                    </ul>
                </div>
            </div>
            <div className="form-row">
                <div className="w-100">
                    <label className={`checkbox-text d-block ${isMobile ? "text-light" : ""}`}>
                        Lütfen aşağıdaki kutucukları tıklamadan önce Kişisel Verilerin İşlenmesine İlişkin{" "}
                        <a
                            className="fw-bold"
                            onClick={() => {
                                showAgreementModal("aydinlatma-metni");
                            }}
                        >
                            Aydınlatma Metnini
                        </a>{" "}
                        okuyunuz.
                    </label>
                </div>
            </div>

            <div className="form-row">
                <div className="w-100">
                    <div className="checkbox">
                        <input
                            id="privacy"
                            type="checkbox"
                            {...register("privacy")}
                            onClick={(e) => {
                                handleAgreementCheckbox(e, "acik-riza-metni");
                            }}
                        />
                        <label htmlFor="privacy" className="checkbox-text d-block">
                            Pazarlama ve analiz çalışmalarının yapılarak bana özel fırsatlar ile hizmetlerin sunulabilmesi amaçlarıyla kişisel verilerimin işlenmesine izin veriyorum. Pazarlama ve analiz çalışmalarına izin vermeniz halinde işlenecek kişisel verilerinize yönelik aydınlatma metnini okumak için
                            <a className="fw-bold"> tıklayınız.</a>
                        </label>
                    </div>
                    {errors.privacy &&
                        <p className="invalid-feedback">Açık rıza metnini kabul etmeden devam edemezsiniz.</p>}
                </div>
            </div>

            <div className="form-row">
                <div className="w-100 checkbox">
                    <input
                        id="commercial"
                        type="checkbox"
                        {...register("commercial", {required: false})}
                        onClick={(e) => {
                            handleAgreementCheckbox(e, "elektronik-ticari-ileti-kurallari");
                        }}
                    />
                    <label htmlFor="commercial" className="checkbox-text d-block">
                        4Nala’nın tanıtım ve fırsatlarından haberdar olmak için ticari elektronik ileti gönderilmesini onaylıyorum. Elektronik ticari iletilerin gönderilmesi için onay vermeniz halinde işlenecek kişisel verilerinize yönelik aydınlatma metnini okumak için
                        <a className="fw-bold"> tıklayınız.</a>
                    </label>
                </div>
            </div>

            <div className="form-row">
                <div className="w-100">
                    <div className="checkbox">
                        <input
                            id="terms"
                            type="checkbox"
                            {...register("terms", {required: true})}
                            onClick={(e) => {
                                handleAgreementCheckbox(e, "uyelik-sozlesmesi");
                            }}
                        />
                        <label htmlFor="terms" className="checkbox-text d-block">
                            <a className="fw-bold">4Nala Üyelik Sözleşmesini okudum</a>, kabul ediyorum.
                        </label>
                    </div>
                    {errors.terms &&
                        <p className="invalid-feedback">Üyelik sözleşmesini kabul etmeden devam edemezsiniz.</p>}
                </div>
            </div>

            <button id="id_btnRegister" className="btn btn-warning w-100 " type="submit">
                ÜYE OL
            </button>

            <div className="d-flex justify-content-center mt-2">
                <a className="text-center" href="/giris-yap">
                    Zaten bir hesabım var.
                </a>
            </div>
        </form>
    );
}
